"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remapRelativeSignal = remapRelativeSignal;
exports.remapBoundaryTarget = remapBoundaryTarget;
exports.remapBoundaryDefinition = remapBoundaryDefinition;
function lookupOrOrphan(id, map, fieldPath, opts) {
    const replacement = map.get(id);
    if (replacement === undefined) {
        opts?.onOrphan?.(id, fieldPath);
        return id;
    }
    return replacement;
}
function remapRelativeSignal(rs, map, fieldPath, opts) {
    const sig = rs.signal;
    if (sig === undefined || sig === null) {
        return;
    }
    if (Array.isArray(sig)) {
        rs.signal = sig.map((id, i) => lookupOrOrphan(String(id), map, `${fieldPath}[${i}]`, opts));
        return;
    }
    rs.signal = lookupOrOrphan(String(sig), map, fieldPath, opts);
}
function remapBoundaryTarget(target, map, fieldPath, opts) {
    if (!target) {
        return;
    }
    if (!('signal' in target)) {
        return;
    }
    remapRelativeSignal(target, map, `${fieldPath}.signal`, opts);
}
function remapBoundaryDefinition(def, map, fieldPath, opts) {
    if (!def) {
        return;
    }
    remapBoundaryTarget(def.target, map, `${fieldPath}.target`, opts);
    remapBoundaryTarget(def.relative_to, map, `${fieldPath}.relative_to`, opts);
    const connection = def.connection;
    if (Array.isArray(connection)) {
        connection.forEach((rs, i) => remapRelativeSignal(rs, map, `${fieldPath}.connection[${i}]`, opts));
    }
}
//# sourceMappingURL=signal-id-remap-internal.js.map